{
    "Address": "Adresa",
    "Bank Account": "Bankovní účet",
    "CofC Number": "HKČR číslo",
    "P.O. Box 9663": "Postbus 9663",
    "The Netherlands": "The Netherlands",
    "VAT Number": "DPH identifikační číslo"
}

